import React from 'react'
import { useLanguage } from '../../hooks/useLanguage'
import { CTAButton } from '../ui'

const ProPitch = ({openContactModal}) => {
  const { lang } = useLanguage()

  return (
    <>
      <div className='relative z-0'>
        <h3 className='text-[32px] font-bold text-center text-[#333]' style={{ position: 'relative', zIndex: 2 }}>
          <span className='font-bold text-center text-[#333]'>それは</span>
          <span className='font-bold text-center text-[#333]'>
            WEBサイトを<span className='bg-yellow-underline bg-no-repeat bg-[length:100%_60px] bg-[position:left_bottom_5px] inline-block'>最適化</span>していないからです!
          </span>
        </h3>
      </div>
      <div className='lg:flex gap-10 justify-center items-center lg:py-10'>
        <div className='lg:py-0 py-8 lg:max-w-sm'>
          <p className='text-xl text-center text-[#333] leading-170'>
            お客様のWebサイトが最適化されているか無料でチェックいたします！
          </p>
        </div>
        <div className='flex justify-center z-0'>
          <CTAButton onClick={openContactModal}>無料チェックを頼む</CTAButton>
        </div>
      </div>
    </>
  )
}

export default ProPitch
